// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteInvoice_root__r4riA"};